import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useBloomreachPageModels } from './use-bloomreach-page-models.js';
import { useBloomreachPageName } from './use-bloomreach-page-name.js';

function useBloomreachProductRoutes() {
    const pageModels = useBloomreachPageModels();
    const pageName = useBloomreachPageName();
    var ref;
    const productRoutes = (ref = pageModels === null || pageModels === void 0 ? void 0 : pageModels.productRoutes) !== null && ref !== void 0 ? ref : {};
    const hasRoutes = Object.keys(productRoutes).length > 0;
    if (!hasRoutes) {
        console.log(`Could not get productRoutes for page with name ${pageName}, got: ${JSON.stringify(productRoutes)}`);
    }
    // Omit a $ref from the productRoutes object
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const routes = swcHelpers.objectWithoutProperties(productRoutes, [
        "$ref"
    ]);
    return React.useMemo(()=>[
            {
                hasRoutes
            },
            routes
        ]
    , [
        hasRoutes,
        routes
    ]);
}

export { useBloomreachProductRoutes };
//# sourceMappingURL=use-bloomreach-product-routes.js.map
